<template lang="pug">
f7-popup(:opened='opened')
  f7-page
    popup-navigation-bar(title='', @close='$emit("close")')
    background
      iframe(
        v-if='opened'
        width='100%',
        height='auto',
        :src='videoUrl',
        frameborder='0',
        allowfullscreen,
        allow='autoplay'
      )
</template>

<script>
export default {
  props: {
    opened: { type: Boolean },
    videoUrl: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/public-common.scss';

.background {
  display: flex;
  align-items: center;
}

@media (max-width: 320px) {
  iframe {
    height: 200px;
  }
}

@media (max-width: 991px) and (min-width: 321px) {
  iframe {
    height: 250px;
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  iframe {
    height: 400px;
  }
}

@media (min-width: 992px) {
  iframe {
    height: 560px;
  }
}

@media (min-height: 630px) and (min-width: 630px) {
  .popup:not(.popup-tablet-fullscreen) {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: 0;
    margin-top: 0;
  }
}
</style>
